import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";
import { useEffect } from "react";

const TableELLSelectField = ({
  element,
  option,
  error,
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  setFieldValue,
  handleResetELCList,
  handleTableELLValueChange,
  formData,
  disabled,
}) => {
  let optionsData = option;

  useEffect(() => {
    const hasInitialValue =
      formData &&
      formData[tableName] &&
      formData[tableName][tdkeys] &&
      formData[tableName][tdkeys][name] != null &&
      formData[tableName][tdkeys][name] !== "";
    if (hasInitialValue && element && Array.isArray(element.options)) {
      const labelValue = formData[tableName][tdkeys][name];
      const optionObj = element.options.find((o) => o.label === labelValue);
      const combined = optionObj
        ? `${labelValue}|${optionObj.value}`
        : "";
      setFieldValue(`${tableName}[${tdkeys}].${name}`, combined);
      handleTableELLValueChange(tdkeys, combined);
    }
  }, [formData]);
  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue(`${tableName}[${tdkeys}].${name}`, value);
    handleTableELLValueChange(tdkeys, value);
    handleResetELCList(true);
  };

  return (
    <div className="wrapper">
      <div className="form-field">
        <Field
          as="select"
          className={`tableInput ${errorBorder}`}
          id={id + tdkeys + 1}
          rowkeys={tdkeys}
          tdkeys={rowkeys}
          name={`${tableName}[${tdkeys}].${name}`}
          onChange={handleChange}
          data-testid="TableELLSelectField"
          disabled={disabled}
        >
          <option value=""></option>
          {optionsData.map((i, index) => (
            <option key={index} value={`${i.label}|${i.value}`}>
              {i.label}
            </option>
          ))}
        </Field>
        {error?.[name] && (
          <span className="icon">
            <Tooltip title={error[name]}>
              <WarningIcon sx={{ color: pink[500] }} />
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default TableELLSelectField;
